import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { BuyButton } from "@/components/BuyButton";
import { SectionHeading } from "@/components/SectionHeading";
import { Container } from "@/components/Container";
import { FaqAccordion } from "@/components/FaqAccordion";
import { STORE } from "@/constants/testIds";

export default function FAQPage() {
  return (
    <div data-testid={STORE.faqPage} className="bg-[var(--ibp-offwhite)]">
      <section className="bg-[var(--ibp-navy-950)] py-12 text-white sm:py-16">
        <Container>
          <SectionHeading
            tone="navy"
            kicker="FAQ"
            title="Frequently asked questions"
            subtitle="Straight answers about what this is, what it isn’t, and what you get."
          />
        </Container>
      </section>

      <section className="py-14 sm:py-20">
        <Container>
          <div className="mx-auto max-w-3xl">
            <FaqAccordion />
            <div className="mt-10 rounded-2xl border border-[color:rgba(10,27,51,0.12)] bg-white p-6 text-center">
              <p className="text-sm text-[color:rgba(11,18,32,0.7)]">
                Still have a question?
              </p>
              <div className="mt-4 flex flex-col items-center justify-center gap-3 sm:flex-row">
                <BuyButton testId="faq-buy-cta" variant="primaryLight" />
                <Link
                  to="/contact"
                  className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#0F3D8A] hover:underline"
                >
                  Contact us <ArrowRight className="h-4 w-4" />
                </Link>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </div>
  );
}
